import React, { useEffect, useContext } from "react";
import Row from "@amzn/meridian/row";
import FPHView from "../FPH/FPHViewv2";
import ComplianceView from "../complaince/complianceViewv2";
import { getNodeCapability } from "../handler/ParentDataHandler";
import { CapabilityContext } from "./context/CapabilityContext";
import WIPView from "../WIP/WIPView";
import TVView from "../WIP/TVView";
import { getRefreshInterval } from "./utils/utils";
import { DEFAULT_CAPABILITIES } from "../outboundAmzl/util/Constants";
import { PVAOverviewContext } from "./context/PVAOverviewContext";
import Column from "@amzn/meridian/column";
import RefreshTimer from "../RefreshTimer";
import { SMALL } from "../common/constant/BreakPoints";
import Responsive from "@amzn/meridian/responsive";
import { useDeviceLayout } from "../common/context/DeviceLayoutContext";

const OverviewView = (props) => {
  const { capability, dispatch } = useContext(CapabilityContext);
  const { pvaData } = useContext(PVAOverviewContext);
  const { spacingInset_shorthand4 } = useDeviceLayout();

  useEffect(() => {
    getNodeCapability().then((capabilities) => {
      dispatch({ type: "GET_CAPABILITIES", capabilities });
    });
  }, []);

  // <OCRView ocr={{processName: "ontimeCompletionRisk", refreshRate: getRefreshInterval()}}/>
  //<WIPView wip={{processName: "expectedTimeToBuildWip", refreshRate: getRefreshInterval()}}/>

  return (
    <Responsive
      query="max-width"
      props={{
        widths: {
          default: ["grid-4", "grid-4", "grid-4"],
          [SMALL]: ["100%", "100%", "100%"],
        },
      }}
    >
      {({ widths }) => (
        <Column spacing="medium" spacingInset={spacingInset_shorthand4}>
          <RefreshTimer deps={[pvaData]} />
          <Row widths={widths} wrap="down" alignmentVertical="stretch">
            <TVView
              tv={{
                processName: "totalVolume",
                refreshRate: getRefreshInterval(),
              }}
            />
            <FPHView
              fph={{ processName: "induct", refreshRate: getRefreshInterval() }}
            />
            {DEFAULT_CAPABILITIES.includes(capability.data) ? (
              <FPHView
                fph={{ processName: "sort", refreshRate: getRefreshInterval() }}
              />
            ) : null}
          </Row>
          <Row widths={widths} wrap="down" alignmentVertical="stretch">
            {DEFAULT_CAPABILITIES.includes(capability.data) ? (
              <ComplianceView
                compliance={{
                  processName: "scanCompliance",
                  refreshRate: getRefreshInterval(),
                }}
              />
            ) : null}
            <WIPView
              breaksDataSources={props.breaksDataSources}
              wip={{
                processName: "stowWipCompliance",
                refreshRate: getRefreshInterval(),
              }}
            />
            <WIPView
              breaksDataSources={props.breaksDataSources}
              wip={{
                processName: "stowWip",
                refreshRate: getRefreshInterval(),
              }}
            />
          </Row>
        </Column>
      )}
    </Responsive>
  );
};

export default OverviewView;



// WEBPACK FOOTER //
// ./src/components/overview/OverviewViewv2.js